export function hidePreloadDiv() {
	const preloadDiv = document.getElementById("preloader") as any;
	preloadDiv.style.display = "none";
}

export function showPreloadDiv() {
	const preloadDiv = document.getElementById("preloader") as any;
	preloadDiv.style.display = "flex";
}
